class CartUpsell extends HTMLElement {
  constructor() {
    super();
    this.cartUpdateUnsubscriber = undefined;
    this.addEventListener('click', this.onClick.bind(this));
    this.addEventListener('change', this.onChange.bind(this));
  }

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-upsell') return;
      this.refreshSection();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  get addButton() {
    return this.querySelector('[data-cart-upsell-add]');
  }

  get errorElement() {
    return this.querySelector('[data-cart-upsell-error]');
  }

  getSectionInnerHTML(html, selector) {
    const element = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return element ? element.innerHTML : '';
  }

  syncVisibility() {
    const contents = this.querySelector('.cart-upsell__contents');
    const hasCard = contents && contents.querySelector('.cart-upsell__card');
    this.classList.toggle('hidden', !hasCard);
  }

  refreshCartSections() {
    const tasks = [];

    const cartItems = document.querySelector('cart-items');
    if (cartItems) {
      tasks.push(cartItems.onCartUpdate());
    }

    const cartFooter = document.getElementById('main-cart-footer');
    if (cartFooter?.dataset.id) {
      tasks.push(
        fetch(`${routes.cart_url}?section_id=${cartFooter.dataset.id}`)
          .then((response) => response.text())
          .then((responseText) => {
            const target = cartFooter.querySelector('.js-contents');
            const source = this.getSectionInnerHTML(responseText, '.js-contents');
            if (source && target) target.innerHTML = source;
            cartFooter.classList.remove('is-empty');
          })
      );
    }

    const cartIcon = document.getElementById('cart-icon-bubble');
    if (cartIcon) {
      tasks.push(
        fetch(`${routes.cart_url}?section_id=cart-icon-bubble`)
          .then((response) => response.text())
          .then((responseText) => {
            cartIcon.innerHTML = responseText;
          })
      );
    }

    const cartItemsElement = document.querySelector('cart-items');
    if (cartItemsElement) {
      cartItemsElement.classList.remove('is-empty');
    }

    return Promise.all(tasks).then(() => this.refreshSection());
  }

  refreshSection() {
    if (!this.dataset.sectionId) return Promise.resolve();

    return fetch(`${routes.cart_url}?section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((responseText) => {
        const source = new DOMParser().parseFromString(responseText, 'text/html').querySelector('.cart-upsell__contents');
        const target = this.querySelector('.cart-upsell__contents');
        if (!source || !target) return;

        target.innerHTML = source.innerHTML;
        this.syncVisibility();
      })
      .catch((error) => console.error(error));
  }

  onChange(event) {
    if (!event.target.matches('[data-cart-upsell-variant]')) return;
    const button = this.addButton;
    if (button) button.dataset.variantId = event.target.value;
  }

  onClick(event) {
    if (!event.target.closest('[data-cart-upsell-add]')) return;
    this.onAddClick(event);
  }

  onAddClick(event) {
    event.preventDefault();
    const button = this.addButton;
    if (!button || button.classList.contains('loading')) return;

    const variantId = button.dataset.variantId;
    if (!variantId) return;

    this.clearError();
    button.classList.add('loading');
    button.setAttribute('aria-disabled', 'true');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.showError(response.description || response.message || window.cartStrings.error);
          return;
        }

        return this.refreshCartSections().then(() => {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'cart-upsell',
            productVariantId: variantId,
            cartData: response,
          });
        });
      })
      .catch(() => {
        this.showError(window.cartStrings.error);
      })
      .finally(() => {
        button.classList.remove('loading');
        button.removeAttribute('aria-disabled');
      });
  }

  showError(message) {
    if (!this.errorElement) return;
    this.errorElement.textContent = message;
    this.errorElement.classList.remove('hidden');
  }

  clearError() {
    if (!this.errorElement) return;
    this.errorElement.textContent = '';
    this.errorElement.classList.add('hidden');
  }
}

customElements.define('cart-upsell', CartUpsell);
